export const decodeBase64UrlToString = (value) => {
  const normalized = String(value || '')
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  if (!normalized) {
    return '';
  }

  const padded = normalized + '='.repeat((4 - (normalized.length % 4)) % 4);

  if (typeof globalThis?.atob === 'function') {
    return globalThis.atob(padded);
  }

  if (typeof Buffer !== 'undefined') {
    return Buffer.from(padded, 'base64').toString('utf8');
  }

  return '';
};
